// extracted by mini-css-extract-plugin
export var footer = "_sn-0";
export var inherit = "_sn-1";
export var input = "_sn-2";
export var modalContent = "_sn-3";
export var quillEditor = "_sn-4";
export var subtitle = "_sn-5";